import React, { useState } from 'react';
import { formatDateTimeHumanFriendly } from '../../../utils/formatters';
import ElipsisBox from '../../Shared/ElipsisBox';
import styled from 'styled-components';
import MaterialModal from '../../MaterialModal/MaterialModal';
import PharmacyModalContent from './PharmacyNotes/PharmacyModalContent';
import { MODAL } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getPharmacyNotesReset } from '../../../redux/notes/getNotesReducer';
import { addPharmacyNoteReset } from '../../../redux/notes/addNoteReducer';
import useLocationQuery from '../../../hooks/useQuery';
import { getDashboardOrders } from '../../../redux/dashboard';
import { EmptyField } from '../../../healtheraComponents';

const LastSupportNote = ({ lastNote, date, pharmacyId }) => {
  const [isPharmacyModalOpen, setIsPharmacyModalOpen] = useState(false);
  const { note } = useSelector((state) => state.addNote);
  const query = useLocationQuery();

  const dispatch = useDispatch();

  const handlePharmacyModalClose = () => {
    setIsPharmacyModalOpen(false);
    if (note) {
      dispatch(getDashboardOrders(query));
    }
  };

  const handlePharmacyModalOpen = () => {
    dispatch(getPharmacyNotesReset());
    dispatch(addPharmacyNoteReset());
    setIsPharmacyModalOpen(true);
  };

  return (
    <>
      {lastNote && date ? (
        <>
          <ElipsisBoxWrapper
            onClick={handlePharmacyModalOpen}
            maxLine={1}
            text={lastNote}
          />
          <DateWrapper>{formatDateTimeHumanFriendly(date * 1000)}</DateWrapper>
          <MaterialModal
            open={isPharmacyModalOpen}
            handleClose={handlePharmacyModalClose}
          >
            <PharmacyModalContent
              pharmacyId={pharmacyId}
              initialContent={MODAL.NOTES_LIST}
            />
          </MaterialModal>
        </>
      ) : (
        <EmptyNoteField />
      )}
    </>
  );
};

export const ElipsisBoxWrapper = styled(ElipsisBox)`
  text-decoration: underline;
  margin-bottom: 8px;
  overflow-wrap: break-word;
  cursor: pointer;
`;

export const DateWrapper = styled.div`
  font-size: 10px;
`;

export const EmptyNoteField = styled(EmptyField)`
  text-align: left;
`;

export default LastSupportNote;
